import { cn } from "@/lib/utils";
import { ClipboardList, Check, X, Clock } from "lucide-react";

interface Commitment {
  text: string;
  context?: string | null;
  turn: number;
  status: string;
  resolved_turn?: number;
}

interface PlayerCommitmentsProps {
  commitments: Commitment[];
}

export function PlayerCommitments({ commitments }: PlayerCommitmentsProps) {
  if (!commitments || commitments.length === 0) return null;

  const active = commitments.filter((c) => c.status === "active");
  const resolved = commitments.filter((c) => c.status !== "active").slice(-3);

  if (active.length === 0 && resolved.length === 0) return null;

  return (
    <div className="mt-3 rounded-lg border border-primary/20 bg-primary/5 p-3 space-y-2">
      <div className="flex items-center gap-1.5 text-xs font-semibold text-primary">
        <ClipboardList className="w-3.5 h-3.5" />
        Plans & Promises
        {active.length > 0 && (
          <span className="ml-auto text-[10px] font-normal text-muted-foreground">
            {active.length} active
          </span>
        )}
      </div>

      {active.map((c, i) => (
        <div
          key={`a-${i}`}
          className="flex items-start gap-2 text-xs text-foreground/90 pl-1"
        >
          <span className="mt-0.5 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
          <div className="min-w-0">
            <p className="leading-relaxed">{c.text}</p>
            {c.context && (
              <p className="text-[10px] text-muted-foreground mt-0.5">{c.context}</p>
            )}
          </div>
        </div>
      ))}

      {resolved.map((c, i) => {
        const icon =
          c.status === "fulfilled" ? <Check className="w-3 h-3 text-green-500" /> :
          c.status === "broken" ? <X className="w-3 h-3 text-destructive" /> :
          <Clock className="w-3 h-3 text-muted-foreground" />;
        return (
          <div
            key={`r-${i}`}
            className="flex items-start gap-2 text-xs text-muted-foreground/70 pl-1 line-through decoration-muted-foreground/30"
          >
            <span className="mt-0.5 shrink-0">{icon}</span>
            <p className="leading-relaxed">{c.text}</p>
          </div>
        );
      })}
    </div>
  );
}
